"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shadows = void 0;
var shadows = {
  shadow300: '0 0 6px 0 rgba(0, 0, 0, 0.08)',
  shadow500: '0 0 10px 0 rgba(0, 0, 0, 0.12)',
  shadow700: '0 0 15px 0 rgba(0, 0, 0, 0.15)'
};
exports.shadows = shadows;